/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface InvoiceDetails
 */
export interface InvoiceDetails {
    /**
     *
     * @type {string}
     * @memberof InvoiceDetails
     */
    totalDisplay: string;
    /**
     *
     * @type {Date}
     * @memberof InvoiceDetails
     */
    periodEnd: Date;
}

/**
 * Check if a given object implements the InvoiceDetails interface.
 */
export function instanceOfInvoiceDetails(value: object): value is InvoiceDetails {
    if (!('totalDisplay' in value) || value['totalDisplay'] === undefined) return false;
    if (!('periodEnd' in value) || value['periodEnd'] === undefined) return false;
    return true;
}

export function InvoiceDetailsFromJSON(json: any): InvoiceDetails {
    return InvoiceDetailsFromJSONTyped(json, false);
}

export function InvoiceDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceDetails {
    if (json == null) {
        return json;
    }
    return {

        'totalDisplay': json['total_display'],
        'periodEnd': (new Date(json['period_end'])),
    };
}

  export function InvoiceDetailsToJSON(json: any): InvoiceDetails {
      return InvoiceDetailsToJSONTyped(json, false);
  }

  export function InvoiceDetailsToJSONTyped(value?: InvoiceDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'total_display': value['totalDisplay'],
        'period_end': ((value['periodEnd']).toISOString().substring(0,10)),
    };
}
